import { graphql } from 'gatsby';
import { useStaticQuery } from 'gatsby';
import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import { IStaticContentfulImages } from 'src/types/contentful';
import { LearnMoreStack } from './ResourcesMegaMenu.styles';
import MegaMenuLearnMore from 'src/app/molecules/Header/MegaMenu/MegaMenuLearnMore';

const ResourcesMegaMenuLearnMore = (): JSX.Element => {
  const { binge, faq, masterclass } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      binge: contentfulAsset(contentful_id: { eq: "4MPvH8DYgPPR9uQFIsSV3V" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 300)
      }
      faq: contentfulAsset(contentful_id: { eq: "5oMA4gdDZ4QlCt1STBo4Hh" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 300)
      }
      masterclass: contentfulAsset(contentful_id: { eq: "K2fXyKyZQcVJyjnfMDRwr" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 300)
      }
    }
  `);

  const learnMoreLinks = [
    {
      image: binge.gatsbyImageData,
      alt: 'Binge',
      title: 'Binge the podcast',
      description: '100,000+ subscribers are already learning how to build a better community.',
      href: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa',
      linkText: 'Listen to the podcast',
    },
    {
      image: faq.gatsbyImageData,
      alt: 'FAQ',
      title: 'FAQ',
      description: 'Explore our help center. To talk to a human, log into your Mighty Network, or attend a free event.',
      href: 'https://faq.mightynetworks.com/en/',
      linkText: 'Get help',
    },
    {
      image: masterclass.gatsbyImageData,
      alt: 'Masterclass',
      title: 'Masterclass',
      description: 'Watching the class is free. Perfecting your community design in 9 steps? Priceless.',
      href: '/peoplemagic',
      linkText: 'View the masterclass',
    },
  ];

  return (
    <LearnMoreStack
      direction='column'
      align='flex-start'
      justify='flex-start'
      gap={'spacing-lg'}
      borderRadius={'radius-2xl'}
      background='bg-secondary'
      padding={['spacing-3xl', 'spacing-4xl', 'spacing-3xl', 'spacing-3xl']}
    >
      <Typography
        type='paragraph'
        size='sm'
        fontWeight='font-weight-semibold'
        color='text-brand-secondary'
      >
        Featured
      </Typography>
      <Stack
        direction='column'
        align='flex-start'
        justify='flex-start'
        gap='spacing-xxs'
      >
        {learnMoreLinks.map((link) => (
          <MegaMenuLearnMore
            key={link.title}
            {...link}
          />
        ))}
      </Stack>
    </LearnMoreStack>
  );
};

export default ResourcesMegaMenuLearnMore;
